// Elements
const logoSpinner = document.getElementById('campaign-hero-logo-spinner');

export class CampaignHeroLogoSpinner {
  private interval: number;
  private logos: NodeListOf<Element> | never[];
  private current: number;

  constructor(interval = 2000) {
    this.interval = interval;
    this.logos = logoSpinner?.querySelectorAll('.logo') ?? [];
    this.current = 0;

    // Check if the user prefers reduced motion.
    // Then show random logo from the list and return early from the constructor
    // ie. don't start the spinner.
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this.logos[this.current].classList.remove('visible');
      const randomLogoIndex = Math.floor(Math.random() * this.logos.length);
      this.logos[randomLogoIndex].classList.add('visible');
      return;
    }

    if (this.logos.length > 0) {
      this.initSpinner();
    }
  }

  initSpinner() {
    const loopInterval = setInterval(() => {
      this.logos[this.current].classList.remove('visible');
      this.current = this.current + 1;

      // After the forst loop, reset to the first logo and stop
      if (this.current >= this.logos.length) {
        this.current = 0;
        clearInterval(loopInterval);
      }

      this.logos[this.current].classList.add('visible');
    }, this.interval);
  }
}
